import { create } from 'zustand';

type VisualTranslationStore = {
  requestRestart: (jobId: string) => void;
  // The finished (failed or outdated) job the user wants to run again: the tab shows the start card instead of it.
  restartRequestedFor: null | string;
  resetRestart: () => void;
};

export const useVisualTranslationStore = create<VisualTranslationStore>((set) => ({
  requestRestart: (jobId) => set({ restartRequestedFor: jobId }),
  restartRequestedFor: null,
  resetRestart: () => set({ restartRequestedFor: null }),
}));
